export default __webpack_public_path__ + "static/media/i19.c209b87c.jpeg";